import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgDatabase = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3.981 5.478c-.375.34-.481.622-.481.83s.106.488.481.83c.376.341.961.683 1.748.985 1.568.603 3.785.992 6.271.992s4.703-.389 6.272-.992c.786-.302 1.371-.644 1.747-.985.375-.342.481-.623.481-.83 0-.208-.106-.49-.482-.83-.375-.342-.96-.683-1.747-.986C16.704 3.889 14.487 3.5 12 3.5s-4.703.389-6.271.992c-.787.303-1.372.644-1.748.986M5.19 3.092C6.97 2.408 9.378 2 12 2s5.03.408 6.81 1.092c.887.341 1.657.766 2.218 1.276S22 5.532 22 6.308v11.384c0 .775-.412 1.43-.972 1.94-.561.51-1.33.934-2.218 1.276C17.03 21.592 14.623 22 12 22s-5.03-.408-6.81-1.092c-.887-.342-1.657-.767-2.218-1.276-.56-.51-.972-1.165-.972-1.94V6.308c0-.776.411-1.43.972-1.94s1.33-.935 2.218-1.276M3.5 14.354v3.338c0 .207.106.489.481.83.376.341.96.683 1.747.986 1.569.603 3.786.992 6.272.992s4.703-.39 6.272-.992c.786-.303 1.371-.645 1.747-.986.375-.341.481-.623.481-.83v-3.338c-.48.33-1.055.617-1.69.861-1.78.685-4.187 1.093-6.81 1.093s-5.03-.408-6.81-1.093a8.2 8.2 0 0 1-1.69-.86M20.5 12c0 .207-.106.488-.481.83-.376.34-.96.683-1.747.985-1.569.604-3.786.993-6.272.993s-4.703-.39-6.272-.993c-.786-.302-1.371-.644-1.747-.985-.375-.342-.481-.623-.481-.83V8.662c.48.33 1.055.617 1.69.861 1.78.685 4.188 1.092 6.81 1.092s5.03-.407 6.81-1.092a8.2 8.2 0 0 0 1.69-.86z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgDatabase;
